import BsTable from './index.vue'
export default BsTable